module.exports = __webpack_public_path__ + "static/img/ba.d0289dc0.png";